import React from 'react';
import { ChevronRight } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-navy pt-20 pb-10 border-t border-gold/20" data-id="element-51">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-52">
        <div className="mb-16" data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-8" data-id="element-54">
            Hacé clic y empezá hoy.
          </h2>
          <a href="Link de tu checkout" className="group relative inline-flex items-center justify-center px-10 py-5 text-xl font-bold text-navy bg-gold rounded-lg overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_30px_rgba(201,168,76,0.5)]" data-id="element-55">
            <span className="relative z-10 flex items-center" data-id="element-56">
              Acceder ahora
              <ChevronRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-57" />
            </span>
            <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-58"></div>
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 text-sm text-gray-500 flex flex-col items-center gap-2" data-id="element-59">
          <p data-id="element-60">© 2026 Sistema PRO. Todos los derechos reservados.</p>
          <div className="flex gap-4" data-id="element-61">
            <span data-id="element-62">www.sistemapro.pro</span>
            <span data-id="element-63">|</span>
            <span data-id="element-64">@sistemapro.ar</span>
          </div>
          <p className="mt-4 max-w-2xl text-xs text-gray-600" data-id="element-65">
            Este material es de uso exclusivo del comprador. Queda prohibida su
            reproducción, distribución o reventa parcial o total sin
            autorización expresa de Sistema PRO.
          </p>
        </div>
      </div>
    </footer>;
}